module.exports = __webpack_public_path__ + "static/6-cd751dc5b47bfda7efc706e73fd9fd2b.png";